import Project from "../model/w2dclasses.js";

export class FileRow {
    constructor(theFile) {
        this.id = theFile._id;
        this.name = theFile.name;

        if (this.name == undefined) {
            this.name = theFile.imglink;
            if (theFile.type == "url") {
                // hack, usually urls have the name property set
                this.name = theFile.url;
            }
        }
        this.file = theFile;
        this.isSelected = false;
        this.isSent = (theFile || {}).contentId !== undefined;
    }
}
export class ProjectRow {
    constructor(theProject, selectFn) {
        this.id = theProject._id;
        this.name = theProject.name;
        this.updateCount(0, 0);

        this.project = theProject;
        this.isSelected = false;
        this.selectFn = selectFn;
    }

    updateCount(incoming, sent) {
        this.numRecsIncoming = incoming;
        this.numRecsSent = sent;
        this.numRecsToBeSent = incoming - sent;
    }

    makeSelected() {
        if (this.selectFn !== undefined) {
            return this.selectFn(this.id);
        }
    }
}
